const ADD_TO_LIST = (state, value) => {
  state.map[value.id] = value;
};

const BULK_ADD_TO_LIST = (state, values) => {
  for (const value of values) {
    state.map[value.id] = value;
  }
};

const UPDATE_IN_LIST = (state, value) => {
  if (!state.map[value.id]) {
    state.map[value.id] = value;
  }
  
  Object.assign(state.map[value.id], value);
};

const REMOVE_FROM_LIST = (state, value) => {
  delete state.map[value.id];
};

const CLEAR_LIST = () => {
  state.map = {};
};

const SET_CHAT_READ_MESSAGES = (state, value) => {
  state.lastReadMessages[value.chatId] = value.messages;
};

const UPDATE_LAST_READ_MESSAGE = (state, value) => {
  const currentValue = [...(state.lastReadMessages[value.chatId] || [])];

  const itemIndex = currentValue.findIndex(item => item.id === value.id);
  if (itemIndex !== -1) {
    currentValue[itemIndex] = value;
  } else {
    currentValue.push(value);
  }

  state.lastReadMessages[value.chatId] = currentValue;
};

const SET_UNREAD_COUNT = (state, count) => {
  state.unreadCount = count;
};

export default {
  ADD_TO_LIST,
  BULK_ADD_TO_LIST,
  UPDATE_IN_LIST,
  REMOVE_FROM_LIST,
  CLEAR_LIST,
  SET_CHAT_READ_MESSAGES,
  UPDATE_LAST_READ_MESSAGE,
  SET_UNREAD_COUNT,
};
